//This is for the event that took place on Feburary 6th, 2025
// Event Details: A consulting panel with Nikhil, a consulant from EY, and Nirali, an analyst from Amazon.

import React from 'react'
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; 





function ConsultingPanel() {
  return (
    <div className='social-event-container'>
        <h1>coming soon!</h1>
    </div>
  )
}

export default ConsultingPanel
